import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { useStoreSettings, useHero } from "../hooks/useHomeContent";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absolutize = (u) => {
  if (!u) return "";
  if (/^https?:\/\//i.test(u)) return u;
  return `${BACKEND_URL}${u}`;
};

export default function Footer() {
  const store = useStoreSettings();
  const hero = useHero();
  const textLogo = hero.textLogoImage ? absolutize(hero.textLogoImage) : "";

  return (
    <footer>
      <div className="wrap">
        <div className="foot-top">
          <div className="foot-brand">
            <div className="logo">
              {textLogo ? (
                <img
                  src={textLogo}
                  alt="Alankar Jewellers"
                  className="foot-textlogo"
                  data-testid="footer-textlogo"
                />
              ) : (
                <span className="name">Alankar Jewellers</span>
              )}
              <span className="sub" style={{ color: "#D99149" }}>
                RASTA PETH · PUNE
              </span>
            </div>

            {/* SMALL MAP / DIRECTIONS CARD */}
            <div className="foot-map">
              <div className="foot-map-embed">
                <iframe
                  title="Alankar Jewellers Store Directions"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src={store.mapEmbedUrl}
                ></iframe>
              </div>
              <div className="foot-map-info">
                <div className="foot-map-addr">
                  <MapPin size={16} strokeWidth={1.6} />
                  <div>
                    <strong>Visit our store</strong>
                    <span data-testid="footer-store-address">
                      {store.addressLine1}
                      <br />
                      {store.addressLine2}
                    </span>
                  </div>
                </div>
                <a
                  className="foot-map-cta"
                  target="_top"
                  rel="noreferrer"
                  href={store.directionsUrl}
                  data-testid="footer-directions"
                >
                  Get Directions <ArrowRight size={14} />
                </a>
              </div>
            </div>
          </div>

          <div className="foot-links">
            <div className="foot-col">
              <h5>Explore</h5>
              <a href="/#about">About Us</a>
              <a href="/#collections">Collections</a>
              <a href="/#value">Services</a>
            </div>
            <div className="foot-col">
              <h5>Reach Us</h5>
              <a href={store.telHref} data-testid="footer-phone">
                {store.phone}
              </a>
              <a href={store.mailHref} data-testid="footer-email">
                {store.email}
              </a>
              <a
                target="_top"
                rel="noreferrer"
                href={store.waGeneric}
                data-testid="footer-whatsapp"
              >
                WhatsApp
              </a>
            </div>
            <div className="foot-col">
              <h5>Follow</h5>
              {store.instagram && (
                <a
                  target="_top"
                  rel="noreferrer"
                  href={store.instagram}
                  data-testid="footer-instagram"
                >
                  Instagram
                </a>
              )}
              {store.facebook && (
                <a
                  target="_top"
                  rel="noreferrer"
                  href={store.facebook}
                  data-testid="footer-facebook"
                >
                  Facebook
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="foot-bottom">
          <span>
            © {new Date().getFullYear()} Alankar Jewellers. All rights
            reserved.
          </span>
          <span>
            Rasta Peth, Pune · Handcrafted with trust for 30+ years.
          </span>
        </div>
      </div>
      <a href={store.waGeneric} style={{ display: "none" }} aria-hidden="true">
        wa
      </a>
    </footer>
  );
}
